/**
 * Safe wrapper around localStorage that gracefully handles environments
 * where localStorage is null/unavailable (e.g. Facebook in-app browser,
 * Safari ITP popup windows, private browsing edge cases).
 */
const safeLocalStorage = {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {}
  },
  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {}
  }
};

export default safeLocalStorage;
